const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#F7E3E3",
    style: {
      fill: "#F7E3E3",
      fill: "color(display-p3 0.9683 0.8917 0.8917)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7467 25.32L37.9467 23.2133C37.6133 22.8133 37.3333 22.0667 37.3333 21.5333V19.2667C37.3333 17.8533 36.1733 16.6933 34.76 16.6933H32.4933C31.96 16.6933 31.2 16.4133 30.8 16.08L28.6933 14.28C27.7733 13.4933 26.2667 13.4933 25.3467 14.28L23.2133 16.08C22.8133 16.4133 22.0667 16.6933 21.5333 16.6933H19.2267C17.8133 16.6933 16.6533 17.8533 16.6533 19.2667V21.5333C16.6533 22.0533 16.3867 22.8 16.0533 23.2L14.2533 25.32C13.48 26.2533 13.48 27.7467 14.2533 28.6533L16.0533 30.7733C16.3867 31.16 16.6533 31.92 16.6533 32.44V34.72C16.6533 36.1333 17.8133 37.2933 19.2267 37.2933H21.5467C22.0667 37.2933 22.8267 37.5733 23.2267 37.9067L25.3333 39.7067C26.2533 40.4933 27.76 40.4933 28.68 39.7067L30.7867 37.9067C31.1867 37.5733 31.9333 37.2933 32.4667 37.2933H34.7333C36.1467 37.2933 37.3067 36.1333 37.3067 34.72V32.4533C37.3067 31.92 37.5867 31.1733 37.92 30.7733L39.72 28.6667C40.5333 27.76 40.5333 26.2533 39.7467 25.32ZM26 21.84C26 21.2933 26.4533 20.84 27 20.84C27.5467 20.84 28 21.2933 28 21.84V28.28C28 28.8267 27.5467 29.28 27 29.28C26.4533 29.28 26 28.8267 26 28.28V21.84ZM27 33.4933C26.2667 33.4933 25.6667 32.8933 25.6667 32.16C25.6667 31.4267 26.2533 30.8267 27 30.8267C27.7333 30.8267 28.3333 31.4267 28.3333 32.16C28.3333 32.8933 27.7467 33.4933 27 33.4933Z",
    fill: "#B42318",
    style: {
      fill: "#B42318",
      fill: "color(display-p3 0.7059 0.1373 0.0941)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoService);
export default __webpack_public_path__ + "static/media/noService.7cf9210e09d6292f3ae41825360c4011.svg";
export { ForwardRef as ReactComponent };